import * as React from "react";
const SvgSortieren = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Sortieren">
    <path
      fill="currentColor"
      d="m121.77 172.89-30.54 30.54V61.96c0-4.14-3.36-7.5-7.5-7.5s-7.5 3.36-7.5 7.5v141.47l-30.54-30.54a7.502 7.502 0 1 0-10.61 10.61l43.34 43.34a7.5 7.5 0 0 0 10.61 0l43.34-43.34a7.502 7.502 0 1 0-10.61-10.61ZM210.31 83.11l-30.54-30.54v141.47c0 4.14-3.36 7.5-7.5 7.5s-7.5-3.36-7.5-7.5V52.57l-30.54 30.54a7.502 7.502 0 1 1-10.61-10.61l43.34-43.34a7.5 7.5 0 0 1 10.61 0l43.34 43.34a7.502 7.502 0 1 1-10.61 10.61Z"
    />
  </svg>
);
export default SvgSortieren;
